export default __webpack_public_path__ + "static/media/sidebar-arrow-right.328d9fb4.svg";